import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { stringify } from '../../util/urlHelpers';
import { matchingBuyerSearch } from '../../util/matchingBuyers';
import { NamedLink } from '../../components';

import css from './SectionMatchingBuyers.module.css';

/** Owner-only suggestions based on comparable published criteria, without EBITDA. */
const SectionMatchingBuyers = ({ listing, currentUser, matches }) => {
  if (
    !matchingBuyerSearch(listing, currentUser) ||
    matches?.listingId !== listing?.id?.uuid ||
    !Number.isInteger(matches?.count) ||
    matches.count <= 0
  )
    return null;

  return (
    <section className={css.root}>
      <h2 className={css.heading}>
        <FormattedMessage id="ListingPage.matchingBuyers.title" />
      </h2>
      <p className={css.description}>
        <FormattedMessage id="ListingPage.matchingBuyers.description" />
      </p>
      <NamedLink
        className={css.link}
        name="SearchPageCompradores"
        to={{ search: `?${stringify(matches.searchParams)}` }}
      >
        <FormattedMessage id="ListingPage.matchingBuyers.link" values={{ count: matches.count }} />
      </NamedLink>
    </section>
  );
};

export default SectionMatchingBuyers;
